import React from 'react';
import DHRouter from '~/components/atom/DHRouter';

import { WithNavigationFrame as NotFound } from '~/components/page/404';
import AppsList from './components/AppsList';
import type { RouteComponentProps } from '@gatsbyjs/reach-router';
import withErrorBoundary from '~/hocs/withErrorBoundary';
import ErrorScreen from '~/components/page/ErrorScreen';
import Catalog from '~/Catalog';
import PremiumValueReportDetails from './PremiumValueReport/PremiumValueReportDetails';
import BBWaardecheck from './BBWaardecheck';
import Realworks from './Realworks';
import Zapier from './Zapier';
import VBOWaardecheck from './VBOWaardecheck';
import Hypotheekbond from './Hypotheekbond';
import Trustoo from './Trustoo';
import Contaqt from './Contaqt';
import NvmOAuthResult, {
  nvmOAuthSuccessPath,
} from './BBWaardecheck/components/NvmOAuthSuccess';
import ValueReport from './ValueReport';
import StellaxAi from './StellaxAI';
import Biedwijzer from './Biedwijzer';

type Props = RouteComponentProps;
const Apps: React.FCC<Props> = () => (
  <DHRouter>
    <AppsList path={'/*'} />
    <BBWaardecheck path="bb-waardecheck/*" />
    <NvmOAuthResult path={nvmOAuthSuccessPath} />
    <ValueReport path="value-report/*" />
    <PremiumValueReportDetails path={`premium-value-report/:reportId`} />
    <Realworks path="realworks/*" />
    <Zapier path="zapier/*" />
    <VBOWaardecheck path="matrixian-waardecheck/*" />
    <Hypotheekbond path="hypotheekbond/*" />
    <Trustoo path="trustoo/*" />
    <Contaqt path="contaqt/*" />
    <StellaxAi path="stellax-ai/*" />
    <Biedwijzer path="biedwijzer/*" />
    <NotFound default />
  </DHRouter>
);

export default withErrorBoundary<Props>(
  Apps,
  <ErrorScreen explanation={Catalog.genericUnknownErrorMessage} />,
);
